<template>
    <div id="PatientHistorySearch">
    <Subtitle  v-bind:ServiceID="this.AppServiceID">
       <template v-slot:header>
        <i class="fa fa-tasks"></i><b>Manage Criteria:</b>
      </template> 
    </Subtitle>
    <Card>
    <CardBody>
    <p>Manage Criteria is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
    </p> 
    </CardBody>
    </Card> 
    <b-modal id="AddCriteriaModel" size="lg" v-model="ShowCriteria"  no-close-on-esc no-close-on-backdrop hide-header-close
      ok-variant cancel-variant hide-footer
     header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant> 
     <EdsCriteria v-if="ShowCriteria==true" @criteriadone="closeModal" :TblData="tblrow" :mode="mode" @dosageUpdated="closeModal"></EdsCriteria>
     <template slot="modal-header"   slot-scope="{ close }"> 
        <div>
        <small class="PopUpTitle w-100 text-left ml-2">{{Poptitle}}</small>
      </div> 
      <div v-show="Button=='Edit'"></div>
    </template>  
</b-modal>
     <form class="card  p-3 mb-1" id="SearchForm"> 


<div class="row">
  <div>
    <v-client-table :columns="columns" :data="TblData" :options="options">
         
       <div slot="beforeFilter"  class="VueTables_Adduser">
        <label for="VueTables_Adduser" class="VueTables_user"> Add New Criteria: </label>
          <!-- <button type="button"  v-on:click="ShowCriteria=true" class="btn btn-primary form-control ">Add New Daignosis and Criteria</button> -->
          <button v-on:click="AddDosage()" v-show="true" type="button" class="btn btn-warning btn-sml mt-1 float-left m-2">
             Add New Daignosis and Criteria
           </button>
     </div>
      <span class="pointer" v-on:click="EditDosage(props.row)" slot="edit" slot-scope="props" > <i class="far fa-edit"></i></span>  
   
    </v-client-table>
  </div>
</div>
</form>
 
    </div>
    </template> 
    <script>      
    import Vue from 'vue'; 
    import {mapGetters} from 'vuex'
    import moment from 'moment'
    import axios from 'axios' 
    import Datepicker from 'vuejs-datepicker';
    import LayoutDefault from '@/Common/Default/DefaultLayout.vue'; 
    import Subtitle from '@/Common/Default/SubTitle.vue'; 
    import Modal from '@/Common/ModelPop.vue';
    import Card from "@/Common/Card.vue";
    import CardBody from "@/Common/CardBody.vue";
    import TileNote from "@/Common/TileNote.vue";
    import { PopUpVariant } from '@/Common/Default/PopUpVariant';
    import { request } from 'http';
    import EdsCriteria from '@/components/DPEBB/Administrator/EDSCriteriaAdd.vue'
    //import EdsCriteria from '@/components/DPEBB/Administrator/AddEDSCriteria.vue'
    //import ViewCriteria from '@/components/DPEBB/Administrator/ViewCriteria.vue'
    import Vuelidate from 'vuelidate'
    import {helpers, required, minLength, sameAs, not, maxLength, numeric, integer, between} from 'vuelidate/lib/validators'
    
    Vue.use(Vuelidate);
    export default  {
      props: {
          Type: '1'
      },
      name: 'AddEDS',
      data: function () {
        return {
            tblrow:'',
            mode:'',
            id:'',
            Button: 'Add',
            Poptitle:'Add Dosage Criteria',
            EdsCriteria,
            PopUpVar:PopUpVariant,
            ShowCriteria: false,
            TblData: [],
    columns: [ 'status','edit','diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter','expchangeallow','commentallow','createdby','modifyby'],

    options: {
      texts:{
        //count:"Showing {from} to {to} of {count} records|{count} records|One record",
        first:'First',
        last:'Last',
        //limit:"Records:",
        //page:"Page:",
        //noResults:"No Eds Record Found",
        filterBy:"Filter by {column}",
        loading:'Loading...',
        defaultOption:'Select {column}',
        columns:'Columns'
      },
      headings: { 
        status: "Status",
        diagnosis: "Diagnosis",
        criteria: "Criteria",
        maxedunit: "Max Unit",
        maxedslength: "Max Length",
        minage:"Min Age",
        maxage:"Max Age",
        generateletter:"Generate Letter",
        expchangeallow:"Expiry Change Allow",
        commentallow:"Comment Allow",
        createdby: "Created By",
        modifyby: "Modify By"
      },

      responseAdapter({data}) {
        return {
          data: formatData,
          count: data.length
        };
      },
      summary: false,
      caption: false,
      perPage:10,
      perPageValues:[10],
      dateColumns:['effectivedate','expirydate'],
      footerHeadings: false,
      filterable: false,

      // listColumns: {
      //   claimtype: [
      //     {id: "CL",
      //     text: "Claim"},
      //     {id: "PA",
      //     text: "Prior Approval"}
      //   ]
      // },

      templates: { 
        status(h, row) {
            if(row.status ==true)
            return "Active"
        else
        return  "Inactive"
        },
        commentallow(h, row) {
            if(row.commentallow == 'N')
            return "Not Allowed"
        else if(row.commentallow == 'R') // Optional
        return  "Required"
        else if(row.commentallow == 'O') // Optional
        return  "Optional"
        },  

        maxedunit(h, row) {
            if(row.maxedunit == 'D')
            return "Days"
        else if(row.maxedunit == 'M') // Optional
        return  "Month"
        else if(row.maxedunit == 'Y') // Optional
        return  "Year"
        }, // maxedunit

        generateletter(h, row) {
            if(row.generateletter ==true)
            return "YES"
        else
        return  "NO"
        },
        expchangeallow(h, row) {
          if(row.expchangeallow ==true)
            return "YES"
          else
            return  "NO"
        },

        effectivedate(h, row) {
          return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');
        },
        effectivedate(h, row) {
          return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');
        },
    
      },

      pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: [ 'status','diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter','commentallow','createdby','modifyby'],
          filterable: [ 'status','diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter','commentallow','createdby','modifyby'],
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
    },
    }
    },
    filters: {
          moment: function (date) {
            return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
          },
          stringify(value) {
            return JSON.stringify(value, null, 2)
          }  
        }, 
    
    methods: 
    {
      AddDosage(Rowdata){
                this.mode='Add';
                this.Poptitle="Add Dosage Criteria"
                this.tblrow='';            
                this.ShowCriteria=true;
            },
      EditDosage(Rowdata){     
            this.mode='Edit';
            this.Poptitle="Edit Dosage Criteria"   
            this.tblrow= Rowdata;            
            this.ShowCriteria=true            
            },
        closeModal() { 
          //console.log('closed')
            this.ShowCriteria = false;
            this.loadTable();
        },
        loadTable()
    {

    var vm = this;
    vm.searched = false;
    var params = new URLSearchParams();
     params.append('usergroupid', 1)//this.AppServiceID);
    //axios.get('SaskHealthApi/Code/GetUsersEDSAllocation', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token , params})
    axios.get('SaskHealthApi/Codes/GetAllCriteria?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }}) //,params})
   .then(function (response) {
         vm.TblData=response.data;

      })
      .catch(function (er) {
          //console.log(er)
      });
    }
},

  showMsg(msg,data,Title) {
        this.boxTwo = ''
        this.$bvModal.msgBoxOk(msg, {
        title: Title,
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: 'Close',
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeaderCancel: true,
        centered: true,
      })
        .then(value => {


          this.boxTwo = this.msg;
          if(value)
          {

          }
        })
        .catch(err => {
          // An error occurred
        })
    
    },
        components: { 
                Card,
                CardBody,
                TileNote ,
                Datepicker,
                EdsCriteria,
                Subtitle,
                Modal:Modal,
        },
      computed:{
          UserName(){
              return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
          },
          AllAppLevel(){
              return this.$store.getters.GetAllApplevel;
            } 
      },
    
      created: function() {         
        this.AppServiceID = this.$store.getters.GetDPEBBServiceID; 
        this.DateFormat = this.$store.getters.GetDateFormat;  
        this.$emit('update:layout', LayoutDefault);  
        this.loadTable();
      },
    
      beforeCreate: function() {  
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
      },
    
      mounted: function () { 
      },
    }
     
    
    </script>
    
    <style scopped>
    custom-control-label {
      position: relative;
      margin-bottom: 0;
  }
   
  label {
      display: inline-block;
      margin-bottom: .5rem;
  }
     .row.no-gutter [class*='col-']   {
       padding-right:1px;
       
     }
     .list-group-item {
        position: relative;
        display: block;
        padding: 0px 15px;
        margin-bottom: -1px;
        border: 1px solid #ddd;
        background-color: blue;
        line-height: 1em
    }
    .col-lg-1>div {background-color:#ddd;}
    
    #docimg {
       
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50; 
    }
    #line {
      border-top:1px solid   rgba(7, 14, 109, 0.25);
    }
    
    
    .test-modal .modal {
        padding: 0 !important;
        padding-left: 0px !important;
        overflow-y: scroll;
    }
    
    .test-modal .modal-dialog { 
        max-width: 100%;
        height: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        z-index: 100000;
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
    
    .modal-open {
        padding: 0 !important;
        padding-left: 0px !important;
        overflow-y: scroll;
    }
    
    #phModal {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
     
    </style>